/* eslint-disable quote-props*/
import orderBy from 'lodash/orderBy'
import mergeWith from 'lodash/mergeWith'
import { getRankSortOrder } from 'utils/clan_management/roles.js'

import { CLAN_MANAGEMENT_UPDATE } from 'state/actions/CMT/ClanManagement.js'
import {
    REMOVE_MEMBERS_SUCCESS,
    UPDATE_MEMBERS,
    SORT_MEMBERS,
} from 'state/actions/CMT/MembersOperation.js'
import { BLOCK_TYPES } from 'utils/clan_management/constants'

const defaultIsAsc = {
    'head-player': true,
}

const nameField = (member) => member.name ? member.name.toLocaleLowerCase() : ''

const fieldSorting = {
    'head-role': {
        fields: () => [(member) => getRankSortOrder(member.role), nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'head-player': {
        fields: () => [nameField],
        asc: ['asc'],
        desc: ['desc'],
    },
    'sorties_middle': {
        fields: (statistics) => [(member) => statistics[member.id].sortiesMiddle, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'sorties_champion': {
        fields: (statistics) => [(member) => statistics[member.id].sortiesChampion, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'sorties_legendary': {
        fields: (statistics) => [(member) => statistics[member.id].sortiesLegendary, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'sorties_absolute': {
        fields: (statistics) => [(member) => statistics[member.id].sortiesAbsolute, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'battles-attack': {
        fields: (statistics) => [(member) => statistics[member.id].battles, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'industrial': {
        fields: (statistics) => [(member) => {
            const memberStats = statistics[member.id]
            return (
                memberStats.industrialResourceEarnedAsClanmate +
                memberStats.industrialResourceEarnedAsLegionary +
                memberStats.industrialResourceEarnedInRandomInClanmatePlatoon +
                memberStats.industrialResourceEarnedInRandom +
                memberStats.industrialResourceForClanPurchaseProduct +
                memberStats.industrialResourceClansupply
            )
        }, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'personal_rating': {
        fields: (statistics) => [(member) => statistics[member.id].personalRating, nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'battles_count': {
        fields: (statistics) => [(member) => statistics[member.id].battlesCount || '', nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'wins_percentage': {
        fields: (statistics) => [(member) => statistics[member.id].winsPercentage || '', nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'experience_per_battle': {
        fields: (statistics) => [(member) => statistics[member.id].expPerBattle || '', nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'damage_per_battle': {
        fields: (statistics) => [(member) => statistics[member.id].damagePerBattle || '', nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'days_in_clan': {
        fields: () => ['daysInClan', nameField],
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
    'head-player-status-in-game': {
        fields: () => {
            const memberLogoutAt = (member) => {
                const isActive = member.status === 'online' || member.status === 'busy'
                const logoutAt = member.logoutAt || 0
                return isActive ? Infinity : logoutAt
            }
            return [memberLogoutAt, nameField]
        },
        asc: ['asc', 'asc'],
        desc: ['desc', 'asc'],
    },
}

const sortMembers = (state) => {
    if (!state.sorting.column)
        return state
    const order = state.sorting.isAsc ? 'asc' : 'desc'
    const sorting = fieldSorting[state.sorting.column]
    return {
        ...state,
        members: orderBy(state.members, sorting.fields(state.statistics), sorting[order]),
    }
}

const initialState = {
    members: [],
    updateMembersAt: null,
    statisticsType: BLOCK_TYPES.CLAN_MODES,
    statistics: {},
    sorting: {
        column: 'industrial',
        isAsc: false,
    },
}

export default (state = initialState, action) => {
    switch (action.type) {
    case CLAN_MANAGEMENT_UPDATE:
        return sortMembers({
            ...state,
            updateMembersAt: new Date(),
            members: action.members,
            statisticsType: action.statisticsType,
            statistics: mergeWith(state.statistics, action.statistics, (left, right) => ({ ...left, ...right })),
        })
    case REMOVE_MEMBERS_SUCCESS:
        return {
            ...state,
            members: state.members.filter((member) => (
                !action.memberIds.includes(member.id)
            )),
        }
    case UPDATE_MEMBERS:
        return sortMembers({
            ...state,
            updateMembersAt: new Date(),
            members: action.members,
        })
    case SORT_MEMBERS:
        return sortMembers({
            ...state,
            sorting: {
                column: action.column,
                isAsc: state.sorting.column === action.column ?
                    !state.sorting.isAsc :
                    defaultIsAsc[action.column] || false,
            },
        })
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/CMT/Members.js